module.exports = __webpack_public_path__ + "907c7261b456edabe4c773d9aeb0bc13.svg";